import { render, staticRenderFns } from "./DeleteStaffProfile.vue?vue&type=template&id=59f20d29&"
import script from "./DeleteStaffProfile.vue?vue&type=script&lang=js&"
export * from "./DeleteStaffProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports